import { render } from "./delete.vue?vue&type=template&id=5ea350d6&ts=true"
import script from "./delete.vue?vue&type=script&lang=ts"
export * from "./delete.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__